module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_DA-54e5c01a0dea1ad1bdfecee47499d309.svg";